<script setup lang="ts">import { ref as _ref } from 'vue';

import { faClose } from '@fortawesome/pro-light-svg-icons'
import { faLightbulb } from '@fortawesome/pro-solid-svg-icons'

defineProps<{
  proTip?: boolean
  text: string
}>()

const show = _ref(true)
</script>

<template>
  <div
    v-show="show"
    class="
      omni-search-tip
      w-full
      flex items-center justify-start gap-3
      py-4 px-2 mb-2
      rounded-v2md
      bg-surface-yellow
      <lg:hidden
    "
    style="height: 40px;"
  >
    <GIcon size="md" :icon="faLightbulb" class="text-orange-500"/>
    <span class="flex gap-2 flex-grow">
      <span v-if="proTip" class="text-v2-yellow-amber">ProTip:</span>
      <span class="font-semibold" style="margin-top: 1px;">
        {{ text }}
      </span>
    </span>
    <GIconButton :icon="faClose" @click.prevent.stop="show = false"/>
  </div>
</template>
